// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let React = require("react");
let Divider = require("../../common/Components/Divider.bs.js");
let Spinner = require("../../common/Components/Spinner.bs.js");
let ButtonsV5 = require("../../common/Components/ButtonsV5.bs.js");
let MediaQuery = require("../../../reason/common/Media/MediaQuery.bs.js");
let Theme__Color = require("../../../reason/common/Theme/Theme__Color.bs.js");
let SearchComponents = require("../../../reason/clients/components/SearchComponents.bs.js");
let SegmentedControl = require("../../common/Components/SegmentedControl.bs.js");
let JsxRuntime = require("react/jsx-runtime");
let VisuallyHidden = require("@reach/visually-hidden").default;
let PropertiesPageRelayFilters = require("./PropertiesPageRelayFilters.bs.js");
let PropertiesPageRelayQueryParams = require("./PropertiesPageRelayQueryParams.bs.js");
let PropertiesPageRelayActiveFiltersList = require("./PropertiesPageRelayActiveFiltersList.bs.js");
let PropertiesPageRelayFiltersMobileMenu = require("./PropertiesPageRelayFiltersMobileMenu.bs.js");
let PropertiesPageRelayFiltersDesktopMenu = require("./PropertiesPageRelayFiltersDesktopMenu.bs.js");

function PropertiesPageRelayControls(props) {
  let setSelectedAreas = props.setSelectedAreas;
  let refetch = props.refetch;
  let isRefetching = props.isRefetching;
  let totalCount = props.totalCount;
  let selectedAreas = props.selectedAreas;
  let defaultAreas = props.defaultAreas;
  let match = PropertiesPageRelayQueryParams.use();
  let params = match[0];
  let isDesktop = MediaQuery.isDesktop();
  let match$1 = React.useState(() => false);
  let setMobileMenuIsOpen = match$1[1];
  return JsxRuntime.jsxs("div", {
    children: [
      isDesktop ? JsxRuntime.jsxs("div", {
          children: [
            JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx("div", {
                  children: JsxRuntime.jsxs(SegmentedControl.make, {
                    children: [
                      JsxRuntime.jsx(SegmentedControl.Segment.make, {
                        label: "For Sale",
                        name: "search-type",
                        id: "search-type-for-sale",
                        onChange: param => refetch(undefined, undefined, undefined, p => {
                          let newrecord = {...PropertiesPageRelayQueryParams.preserveRelevantParamsWhenSwitchingModes(p)};
                          newrecord.rentalMode = false;
                          return newrecord;
                        }),
                        checked: !params.rentalMode
                      }),
                      JsxRuntime.jsx(SegmentedControl.Segment.make, {
                        label: "For Rent",
                        name: "search-type",
                        id: "search-type-rental",
                        onChange: param => refetch(undefined, undefined, undefined, p => {
                          let newrecord = {...PropertiesPageRelayQueryParams.preserveRelevantParamsWhenSwitchingModes(p)};
                          newrecord.rentalMode = true;
                          return newrecord;
                        }),
                        checked: params.rentalMode
                      })
                    ]
                  }),
                  className: ""
                }),
                JsxRuntime.jsx(PropertiesPageRelayFiltersDesktopMenu.make, {
                  defaultAreas: defaultAreas,
                  selectedAreas: selectedAreas,
                  setSelectedAreas: setSelectedAreas,
                  refetch: refetch
                })
              ],
              className: "flex flex-row gap-4 items-center flex-wrap flex-1 xl:flex-none lg:pr-4 xl:pr-0"
            }),
            JsxRuntime.jsx("div", {
              children: JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsx("div", {
                    children: isRefetching ? JsxRuntime.jsxs("div", {
                        children: [
                          JsxRuntime.jsx(Spinner.make, {
                            size: 16,
                            stroke: Theme__Color.toString(Theme__Color.jumbo)
                          }),
                          JsxRuntime.jsx(VisuallyHidden, {
                            children: "Loading"
                          })
                        ],
                        className: "h-7.5 pl-4 pb-0.5 flex items-center font-medium text-gray-600"
                      }) : totalCount.toString() + ` results`,
                    className: "flex items-center"
                  }),
                  JsxRuntime.jsxs("div", {
                    children: [
                      JsxRuntime.jsx("div", {
                        children: "Sort by:",
                        className: "text-sm text-gray-500"
                      }),
                      JsxRuntime.jsx(SearchComponents.MenuItem.make, {
                        title: PropertiesPageRelayFilters.SortOrder.labelFor(params.sortOrder),
                        children: JsxRuntime.jsx(PropertiesPageRelayFilters.SortOrder.make, {
                          refetch: refetch
                        }),
                        position: "Right"
                      })
                    ],
                    className: "gap-3 flex flex-col lg:flex-row lg:items-center"
                  })
                ],
                className: "flex xl:items-center justify-start xl:justify-between gap-4 flex-col xl:flex-row"
              }),
              className: "lg:pl-6 pl-4 border-l grow flex-1 xl:flex-auto content-end pb-1"
            })
          ],
          className: "flex flex-row gap-4"
        }) : JsxRuntime.jsxs(JsxRuntime.Fragment, {
          children: [
            JsxRuntime.jsx(ButtonsV5.SecondaryButton.make, {
              onClick: param => setMobileMenuIsOpen(param => true),
              size: "small",
              icon: "filters",
              children: "Edit Filters"
            }),
            JsxRuntime.jsx(PropertiesPageRelayFiltersMobileMenu.make, {
              isOpen: match$1[0],
              onClose: () => setMobileMenuIsOpen(param => false),
              refetch: refetch,
              defaultAreas: defaultAreas,
              selectedAreas: selectedAreas,
              setSelectedAreas: setSelectedAreas,
              isRefetching: isRefetching,
              totalCount: totalCount
            })
          ]
        }),
      JsxRuntime.jsx("div", {
        children: JsxRuntime.jsx(Divider.make, {}),
        className: "my-4"
      }),
      JsxRuntime.jsx(PropertiesPageRelayActiveFiltersList.make, {
        params: params,
        selectedAreas: selectedAreas,
        defaultAreas: defaultAreas,
        refetch: refetch
      })
    ],
    className: "p-6 bg-white rounded-md"
  });
}

let QueryParams;

let DesktopMenu;

let ActiveFiltersList;

let SortOrder;

let MenuItem;

let make = PropertiesPageRelayControls;

exports.QueryParams = QueryParams;
exports.DesktopMenu = DesktopMenu;
exports.ActiveFiltersList = ActiveFiltersList;
exports.SortOrder = SortOrder;
exports.MenuItem = MenuItem;
exports.make = make;
/* react Not a pure module */
